// removed by extract-text-webpack-plugin
module.exports = {"item-title":"_13hH","item-text":"_2qiK"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/BenefitsList/BenefitsList.scss
// module id = 6KGM
// module chunks = 0